// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
import type { PlanDay } from "@/lib/types"

export default function DayToggle({ days, selected, onSelect }: {
  days: PlanDay[]
  selected: string
  onSelect: (dayId: string) => void
}) {
  return (
    <div className="seg">
      {days.map((d) => (
        <button key={d.id} type="button" aria-pressed={d.id === selected} onClick={() => onSelect(d.id)}>
          Tag {d.code}
        </button>
      ))}
    </div>
  )
}
